import { useCallback, useEffect } from 'react';
import { useAuthProvider } from '../utils/auth';
import { claimShareReferral, withShareReferral } from '../utils/referrals';

// Returns a function that tags a public share link with the current user,
// so whoever shares music is credited for listeners it brings in
export const useShareLink = () => {
  const { user } = useAuthProvider();
  const uuid = user?.uuid;
  return useCallback((url) => withShareReferral(url, uuid ? { uuid } : null), [uuid]);
};

// For a track/album/artist page: records a landing from a shared link
// (?ref=...) and returns the share-link tagger
export const useShareReferral = (contentType, contentId) => {
  const { user } = useAuthProvider();
  const uuid = user?.uuid;
  useEffect(() => {
    if (contentId) claimShareReferral(contentType, contentId, uuid ? { uuid } : null);
  }, [contentType, contentId, uuid]);
  return useShareLink();
};
